export const version = '1.15.2';
//# sourceMappingURL=version.js.map